// extracted by mini-css-extract-plugin
module.exports = {"TotalTonnage":"TotalTonnage_TotalTonnage__2G3DD shared_Card__GDlNU","Label":"TotalTonnage_Label__273iQ","Value":"TotalTonnage_Value__OdU1k"};